<script lang="ts">
import { ref } from 'vue'

export default {
  name: 'renderless-careers-team',
  props: {
    selected: {
      type: String,
      required: true
    }
  },
  setup(props, { slots }) {
    const selected = ref<string>(props.selected)
    const select = (title: string) => selected.value = title
    return () => slots.default({
      selected: selected.value,
      select
    })
  }
}
</script>
